module.exports = __webpack_public_path__ + "media/images/lb/750-b118e662e51b15616357e9406b7a7e03.svg";